import {
    createAction,
    props
} from '@ngrx/store';
import { IDatiqFeatureFlag } from '../models';
import { OptimizelyDecision } from '@optimizely/optimizely-sdk';


const createActionName: (name: string) => string = (name: string) => {
    return `[Datiq Feature Flag] ${name}`;
};

export const setUpOptimizelySuccess = createAction(
    createActionName('set up optimzely successfully')
);
export const setUpOptimizelyFail = createAction(
    createActionName('set up optimzely fail'),
    props<{ error: any }>()
);
export const unuseFeatureFlags = createAction(
    createActionName('unuse Feature Flags')
);
export const setFeatureFlags = createAction(
    createActionName('set feature flags'),
    props<{ featureFlags: IDatiqFeatureFlag[] }>()
);
export const enrollExperimentFlag = createAction(
    createActionName('enroll experiment flag'),
    props<{ flagName: string }>()
);
export const enorlledExperimentFlag = createAction(
    createActionName('enrolled experiment flag'),
    props<{ flag: IDatiqFeatureFlag }>()
);
